import React from "react";
import styles from "../../css/shared/CustomSelectOption.module.scss";
import sprite from "../../assets/icons/carets-arrows.svg";
import { PropTypes } from "prop-types";

const CustomSelectOption = ({
	isDisabled = false,
	isSelected = false,
	option,
	customOption = null,
	handleSelect,
}) => {
	const custom = {
		opacity: isDisabled ? ".4" : "1",
		cursor: isDisabled ? "not-allowed" : "pointer",
	};
	return (
		<li
			className={
				isSelected
					? styles.CustomSelectOption_isSelected
					: styles.CustomSelectOption
			}
			onClick={isDisabled ? null : () => handleSelect(option)}
			style={custom}
		>
			{!customOption && <span>{option}</span>}
			{customOption && { option }}
			{isSelected && (
				<svg className={styles.CustomSelectOption_icon}>
					<use xlinkHref={`${sprite}#icon-checkmark-outline`}></use>
				</svg>
			)}
		</li>
	);
};

export default CustomSelectOption;

// single dropdown menu option
CustomSelectOption.defaultProps = {
	isSelected: false,
};
CustomSelectOption.propTypes = {
	isSelected: PropTypes.bool.isRequired,
	option: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	handleSelect: PropTypes.func.isRequired,
};
